<!-- <h2 class="m-0">
  {{dialogData.valuation.title}}
</h2> -->
<button mat-icon-button
  tabindex="-1"
  class="close-dialog"
  (click)="onCancel()">
  <mat-icon>close</mat-icon>
</button>
<!-- [youtubeEmbedUrl]="dialogData.youtubeEmbedUrl" -->
<cci-vehicle-gallery [gallery]="dialogData.gallery"
  size="zoom"
  [showGallery]="true"></cci-vehicle-gallery>